<script setup lang="ts">
import { useGamesTheme } from '../../composables/use-games-theme';
import GamesBackButton from '../../components/GamesBackButton.vue';

const { theme } = useGamesTheme();

const emits = defineEmits<{ (e: 'goBack'): void }>();
</script>

<template>
  <v-theme-provider :theme="theme" with-background class="bg-surface">
    <v-container fluid class="games-layout pa-0">
      <slot></slot>
    </v-container>
    <GamesBackButton @go-back="emits('goBack')" />
  </v-theme-provider>
</template>

<style scoped lang="scss">
.games-layout {
  background-image: var(--v-games-background-image);
  background-size: cover;
  background-position: center;
  font-family: 'Chalkboard', 'Comic Sans MS', sans-serif;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
